// IframeComponent.js
import React from 'react';

const IframeComponent = () => {
  return (
    <iframe 
      src="https://projects.thecity.nyc/2023_10_fidi-infographics/index.html" 
      width="100%" 
      height="675" 
      title="Example Iframe"
      style={{border: "none"}}>
    </iframe>
  );
}

export default IframeComponent;
